import PrivateImage from "./PrivateImage";
import { publicPageUrl } from "../utils/publicPages";
import { React, useState, useEffect } from "react";
import {
  Container,
  Navbar,
  Nav,
  Button,
  Image,
  NavDropdown,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Badge,
} from "react-bootstrap";
import { FaGlobe } from "react-icons/fa";
import { Bell } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../Redux/actions/Useraction";
import { useNavigate } from "react-router-dom";
import {
  getmynotification,
  MarkNotifyRead,
} from "../Redux/actions/Reportaction";
const NavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [user, SetUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : "";
  });
  const [token, SetToken] = useState(() => localStorage.getItem("token") || "");
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      SetUser(JSON.parse(storedUser));
      SetToken(localStorage.getItem("token") || "");
    }
  }, []); // يتم التنفيذ مرة واحدة فقط عند تحميل الكومبوننت

  useEffect(() => {
    if (token) {
      dispatch(getUserData());
      dispatch(getmynotification());
    }
  }, [dispatch, token]);

  const MYData = useSelector((state) => state.alluser.mydata);
  const userimage = MYData?.data?.user?.profileImage;

  const data = useSelector((state) => state.allreport.notify?.data);
  const MYNotify = Array.isArray(data) ? data : [];
  console.log(MYNotify);
  const unreadCount = MYNotify.filter((n) => !n.read).length;

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    SetUser("");
    SetToken("");
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "de" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang); // تحفظ اللغة
  };

  const handleNotificationClick = (notif) => {
    dispatch(MarkNotifyRead(notif._id));

    if (notif.report && notif.patient) {
      navigate(
        `/ExaminationReport/${notif.patient._id || notif.patient}/${notif.report._id || notif.report}`,
      );
      return;
    }

    if (notif.type === "patient_assigned" && notif.patient) {
      navigate("/");
      return;
    }

    navigate("/");
  };

  return (
    <Navbar bg="white" expand="lg" className="shadow-sm">
      <Container>
        <Navbar.Brand href={publicPageUrl(i18n.language, "home")}>
          <PrivateImage
            src={"/logo.png"}
            alt={t("navbar.home")}
            style={{ height: "40px" }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center">
            {user.firstName ? (
              <>
                <Nav.Link href="/">{t("navbar.home")}</Nav.Link>
                <Nav.Link href="/ArchivedPatients">
                  {t("navbar.archived_patients")}
                </Nav.Link>

                {/* ✅ عرض الروابط فقط إذا لم يكن المستخدم دكتور */}

                <Nav.Link href="/PatientPage">
                  {t("navbar.new_patient")}
                </Nav.Link>

                <Dropdown align="end">
                  <Dropdown.Toggle
                      as="div"
                      className="no-caret me-4"
                      style={{ cursor: "pointer", position: "relative" }}
                    >
                      <Bell size={28} />
                      {unreadCount > 0 && (
                        <Badge
                          bg="danger"
                          pill
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-12px",
                            fontSize: "0.75rem",
                          }}
                        >
                          {unreadCount}
                        </Badge>
                      )}
                    </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      minWidth: "320px",
                      maxHeight: "600px",
                      overflowY: "auto",
                    }}
                  >
                    <Dropdown.Header>Notifications</Dropdown.Header>
                    {MYNotify.length > 0 ? (
                      MYNotify.map((notif, index) => (
                        <>
                          <Dropdown.Item
                            onClick={() => handleNotificationClick(notif)}
                            className={
                              !notif.read ? "fw-bold text-dark" : "text-muted"
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {notif.message}
                          </Dropdown.Item>

                          {/* Divider بين النوتيفيشنات */}
                          {index < MYNotify.length - 1 && (
                            <hr style={{ margin: "0.25rem 0", opacity: 0.3 }} />
                          )}
                        </>
                      ))
                    ) : (
                      <Dropdown.Item>No notifications</Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>

                <NavDropdown
                    title={
                      <PrivateImage as={Image}
                        src={userimage || "/profile.jpg"}
                        roundedCircle
                        width="40"
                        height="40"
                        style={{ objectFit: "cover" }}
                        alt={t("navbar.user_avatar")}
                      />
                    }
                    id="user-nav-dropdown"
                    align="end"
                    renderMenuOnMount
                    className="profile-dropdown"
                  >
                  <NavDropdown.Item href="/ProfilePage">
                    {t("navbar.your_profile")}
                  </NavDropdown.Item>

                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={logOut} href="/">
                    {t("navbar.logout")}
                  </NavDropdown.Item>
                </NavDropdown>
                <Button
                  variant="button-color"
                  className="ms-3 d-flex align-items-center gap-1 button-color"
                  onClick={toggleLanguage}
                >
                  <FaGlobe /> {t("navbar.language")} (
                  {i18n.language.toUpperCase()})
                </Button>
              </>
            ) : (
              <>
                <Nav.Link href="/">{t("navbar.home")}</Nav.Link>
                <Nav.Link href={publicPageUrl(i18n.language, "about")}>{t("navbar.about_us")}</Nav.Link>
                <Nav.Link href="/Login">{t("navbar.login")}</Nav.Link>
                <Nav.Link href="/Signup">{t("navbar.registration")}</Nav.Link>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="fundus-tooltip">
                      {t("navbar.fundus_tooltip")}
                    </Tooltip>
                  }
                >
                  <Nav.Link
                    href="https://auge.cloud/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("navbar.for_opticians")}
                  </Nav.Link>
                </OverlayTrigger>
                <Button
                  variant="button-color"
                  className="ms-3 d-flex align-items-center gap-1 button-color"
                  onClick={toggleLanguage}
                >
                  <FaGlobe /> {t("navbar.language")} (
                  {i18n.language.toUpperCase()})
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
